import { __exports as assignmentService } from "../../../../../../_virtual/assignment-service.js";
import { __require as requireHash } from "../util/hash.js";
var hasRequiredAssignmentService;
function requireAssignmentService() {
  if (hasRequiredAssignmentService) return assignmentService;
  hasRequiredAssignmentService = 1;
  (function(exports$1) {
    var __awaiter = assignmentService && assignmentService.__awaiter || function(thisArg, _arguments, P, generator) {
      function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
          resolve(value);
        });
      }
      return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    Object.defineProperty(exports$1, "__esModule", { value: true });
    exports$1.toEvent = exports$1.AmplitudeAssignmentService = exports$1.FLAG_TYPE_MUTUAL_EXCLUSION_GROUP = exports$1.DAY_MILLIS = void 0;
    const hash_1 = requireHash();
    exports$1.DAY_MILLIS = 24 * 60 * 60 * 1e3;
    exports$1.FLAG_TYPE_MUTUAL_EXCLUSION_GROUP = "mutual-exclusion-group";
    class AmplitudeAssignmentService {
      constructor(amplitude, assignmentFilter) {
        this.amplitude = amplitude;
        this.assignmentFilter = assignmentFilter;
      }
      track(assignment) {
        return __awaiter(this, void 0, void 0, function* () {
          if (this.assignmentFilter.shouldTrack(assignment)) {
            this.amplitude.logEvent((0, exports$1.toEvent)(assignment));
          }
        });
      }
    }
    exports$1.AmplitudeAssignmentService = AmplitudeAssignmentService;
    const toEvent = (assignment) => {
      var _a, _b, _c, _d;
      const event = {
        event_type: "[Experiment] Assignment",
        user_id: assignment.user.user_id,
        device_id: assignment.user.device_id,
        event_properties: {},
        user_properties: {}
      };
      const set = {};
      const unset = {};
      for (const flagKey in assignment.results) {
        const variant = assignment.results[flagKey];
        if (!variant.key) {
          continue;
        }
        const version = (_a = variant.metadata) === null || _a === void 0 ? void 0 : _a.flagVersion;
        const segmentName = (_b = variant.metadata) === null || _b === void 0 ? void 0 : _b.segmentName;
        const flagType = (_c = variant.metadata) === null || _c === void 0 ? void 0 : _c.flagType;
        const isDefault = (_d = variant.metadata) === null || _d === void 0 ? void 0 : _d.default;
        event.event_properties[`${flagKey}.variant`] = variant.key;
        if (version && segmentName) {
          event.event_properties[`${flagKey}.details`] = `v${version} rule:${segmentName}`;
        }
        if (flagType != exports$1.FLAG_TYPE_MUTUAL_EXCLUSION_GROUP) {
          if (isDefault) {
            unset[`[Experiment] ${flagKey}`] = "-";
          } else {
            set[`[Experiment] ${flagKey}`] = variant.key;
          }
        }
      }
      event.user_properties["$set"] = set;
      event.user_properties["$unset"] = unset;
      event.insert_id = `${event.user_id} ${event.device_id} ${(0, hash_1.hashCode)(assignment.canonicalize())} ${Math.floor(assignment.timestamp / exports$1.DAY_MILLIS)}`;
      return event;
    };
    exports$1.toEvent = toEvent;
  })(assignmentService);
  return assignmentService;
}
export {
  requireAssignmentService as __require
};
//# sourceMappingURL=assignment-service.js.map
